<!-- viewBox="0 0 16 16" -->
<template>
  <path
    d="M8.00482 12.9907C8.00482 13.2725 7.84196 13.5286 7.58709 13.6481C7.48855 13.6947 7.38296 13.7173 7.27806 13.7173C7.11193 13.7173 6.94735 13.6602 6.81442 13.5499L2.84219 10.2584H0.726585C0.325372 10.2587 0 9.93317 0 9.53196V6.63714C0 6.23576 0.325372 5.91038 0.726585 5.91038H2.84237L6.81459 2.61883C7.03162 2.43894 7.33257 2.40059 7.58727 2.52097C7.84196 2.6405 8.00499 2.89673 8.00499 3.17843L8.00482 12.9907Z"
    fill="currentColor"
  />
</template>
